"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosStockCountCreateInputSchema = exports.APosStockCountSchema = exports.APosStockCountItemSchema = exports.APosStockCountStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosStockCountStatusSchema = zod_1.z.enum([
    'in_progress', 'submitted', 'reviewed', 'applied', 'cancelled',
]);
exports.APosStockCountItemSchema = zod_1.z.object({
    variantId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().optional(),
    expectedQuantity: zod_1.z.number().int().nonnegative(),
    countedQuantity: zod_1.z.number().int().nonnegative(),
    variance: zod_1.z.number().int(),
    variancePercent: zod_1.z.number(),
    notes: zod_1.z.string().max(500).optional(),
});
exports.APosStockCountSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    stockCountId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    scope: zod_1.z.enum(['full', 'category', 'custom']).default('full'),
    scopeCategoryIds: zod_1.z.array(zod_1.z.string()).optional(),
    items: zod_1.z.array(exports.APosStockCountItemSchema).default([]),
    totalExpected: zod_1.z.number().int().nonnegative().default(0),
    totalCounted: zod_1.z.number().int().nonnegative().default(0),
    totalVariance: zod_1.z.number().int().default(0),
    status: exports.APosStockCountStatusSchema.default('in_progress'),
    countedBy: id_schema_1.EntityIdSchema.optional(),
    submittedAt: zod_1.z.number().optional(),
    reviewedBy: id_schema_1.EntityIdSchema.optional(),
    reviewedAt: zod_1.z.number().optional(),
    appliedAt: zod_1.z.number().optional(),
    appliedBy: id_schema_1.EntityIdSchema.optional(),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosStockCountCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    scope: zod_1.z.enum(['full', 'category', 'custom']).optional(),
    scopeCategoryIds: zod_1.z.array(zod_1.z.string()).optional(),
});
//# sourceMappingURL=stock-count.schema.js.map